export const NavigationTypes = {NAVIGATE_TO_PAGE: 'NAVIGATE_TO_PAGE'};

export const BrowserTypes = {SCREEN_RESIZE: 'SCREEN_RESIZE'};
